import React from 'react';
import PropTypes from 'prop-types'

class CloakSnackBar extends React.PureComponent {

    constructor(props){
        super(props)

        this.state = {
        }
    }

  render() {

      return (
            <div className="clk-snack-bar clk-box-shadow">
                <div className="clk-snack-bar-inner-div">
                    {this.props.children}                  
                </div>
            </div>
      	)
    }
}

CloakSnackBar.propTypes = {
  children: PropTypes.node
}

export default CloakSnackBar